import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus/es'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import router from './router'
import './assets/styles/global.css'

const app = createApp(App).use(router)
app.use(ElementPlus, { locale: zhCn })
app.mount('#app')


const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
};
  
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
constructor(callback) {
    super(debounce(callback, 100)); // 延迟100ms触发
    }
};
  
